// extracted by mini-css-extract-plugin
export var button = "quantitySelector-module--button--fece8";
export var disabledLabel = "quantitySelector-module--disabledLabel--4bb11";
export var label = "quantitySelector-module--label--c2e1b";
export var price = "quantitySelector-module--price--8987d";
export var quantity = "quantitySelector-module--quantity--cfc27";
export var selector = "quantitySelector-module--selector--408b8";
export var subtractLabel = "quantitySelector-module--subtractLabel--55ca0";
export var wrapper = "quantitySelector-module--wrapper--4bb05";